
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class APIService {

    static getAPISettings(CompanyCode, email) {
        //var data = [];
        return axios.get(`${BaseUrl}APISettings?Companycode=${CompanyCode}&email=${email}`);
    }

    static SaveViventiumSetting(CompanyCode1, email, UserName, Pass, EasyUserName, EasyPass, CompanyCode, Division) {

        var viventiumData = {
            CompanyCode: CompanyCode,
            UserName: UserName,
            Password: Pass,
            EasyApiUser: EasyUserName,
            EasyApiPassword: EasyPass,
            Division: Division
        };
        return axios.post(BaseUrl+ 'SaveViventiumSetting?CompanyCode1='+CompanyCode1+'&email='+email, viventiumData);
    }

    static SaveGeoTabSetting(CompanyCode, email, UserName, Pass, GeoServer, Database) {

        var VData = {
            UserName: UserName,
            Password: Pass,
            Server: GeoServer,
            Database: Database
        };
        return axios.post(BaseUrl+ 'SaveGeoTabSetting?CompanyCode='+CompanyCode+'&email='+email, VData);
    }
    static SaveEasySchedulingSetting(CompanyCode, email, UserName, Pass, TenantID, EasyApiUser, EasyApiPassword) {

        var VData = {
            UserName: UserName,
            Password: Pass,
            TenantID: TenantID,
            EasyApiUser: EasyApiUser,
            EasyApiPassword: EasyApiPassword
        };
        return axios.post(BaseUrl+ 'SaveEasySchedulingSetting?CompanyCode='+CompanyCode+'&email='+email, VData);
    }

    static SaveJamisSetting(CompanyCode, Company, ServiceAddress, email, UserName, Pass, EasyApiUser, EasyApiPassword) {

        var VData = {
            UserName: UserName,
            Password: Pass,
            EasyApiUser: EasyApiUser,
            EasyApiPassword: EasyApiPassword,
            Company: Company,
            ServiceAddress: ServiceAddress
        };
        return axios.post(BaseUrl+ 'SaveJamisSetting?CompanyCode='+CompanyCode+'&email='+email, VData);
    }

    
    static SaveQuickPaySetting(CompanyCode,email, UserName, Pass, EasyApiUser, EasyApiPassword, PeroId, ClientId, ApiAddress, CustomFieldNameUserId,
                               CustomFieldNameLegacyEmployeeId, CustomFieldNameJobId, UseSalary, ProjAndJobAssignableToAll) {

        var VData = {
            UserName: UserName,
            Password: Pass,
            EasyApiUser: EasyApiUser,
            EasyApiPassword: EasyApiPassword,
            PeoId: PeroId,
            ClientId: ClientId,
            ApiAddress: ApiAddress,
            CustomFieldNameUserId: CustomFieldNameUserId,
            CustomFieldNameLegacyEmployeeId: CustomFieldNameLegacyEmployeeId,
            CustomFieldNameJobId: CustomFieldNameJobId,
            UseSalary: UseSalary,
            ProjAndJobAssignableToAll: ProjAndJobAssignableToAll
        };
        return axios.post(BaseUrl+ 'SaveQuickPaySetting?CompanyCode='+CompanyCode+'&email='+email, VData);
    }

    static SaveOnShiftSetting(CompanyCode,email, UserName, Pass, EasyApiUser, EasyApiPassword,ApiAddress, ExportTimeOutMinutes, CompanyId,Key,
                              FtpPath, FtpFolderBase, FtpUser, FtpPsw, EmailsAlertTo, EmailSubjectError) {

        var VData = {
            UserName: UserName,
            Password: Pass,
            EasyApiUser: EasyApiUser,
            EasyApiPassword: EasyApiPassword,
            ApiAddress: ApiAddress,
            ExportTimeOutMinutes: ExportTimeOutMinutes,
            CompanyId: CompanyId,
            Key: Key,
            FtpPath: FtpPath,
            FtpFolderBase: FtpFolderBase,
            FtpUser: FtpUser,
            FtpPsw: FtpPsw,
            EmailsAlertTo: EmailsAlertTo,
            EmailSubjectError: EmailSubjectError
        };
        return axios.post(BaseUrl+ 'SaveOnShiftSetting?CompanyCode='+CompanyCode+'&email='+email, VData);
    }

    static SaveReportSetting(CompanyCode, email, EmailTo, SerializedSettings) {

        var VData = {
            EmailTo: EmailTo,
            stringSettings: SerializedSettings
        };
        return axios.post(BaseUrl+ 'SaveReportsEmail?CompanyCode='+CompanyCode+'&email='+email, VData);
    }

    static SaveArborSetting(CompanyCode, email, UserName, Pass, LocationName, Division) {

        var VData = {
            UserName: UserName,
            Password: Pass,
            Location: LocationName,
            Division: Division
        };
        return axios.post(BaseUrl+ 'SaveArborSetting?CompanyCode='+CompanyCode+'&email='+email, VData);
    }

    static SaveAdrenalinSetting(CompanyCode,email, UserName, Pass, EasyApiUser, EasyApiPassword,ApiAddress, ExportTimeOutMinutes, CompanyId,Key,
        FtpPath, FtpFolderBase, FtpUser, FtpPsw, EmailsAlertTo, EmailSubjectError) {

        var VData = {
            UserName: UserName,
            Password: Pass,
            EasyApiUser: EasyApiUser,
            EasyApiPassword: EasyApiPassword,
            ApiAddress: ApiAddress,
            ExportTimeOutMinutes: ExportTimeOutMinutes,
            CompanyId: CompanyId,
            Key: Key,
            FtpPath: FtpPath,
            FtpFolderBase: FtpFolderBase,
            FtpUser: FtpUser,
            FtpPsw: FtpPsw,
            EmailsAlertTo: EmailsAlertTo,
            EmailSubjectError: EmailSubjectError
        };
        return axios.post(BaseUrl+ 'SaveAdrenalinSetting?CompanyCode='+CompanyCode+'&email='+email, VData);
    }

    static SaveXeroSetting(CompanyCode,email, SubGroups, EasyApiUser, EasyApiPassword,ApiAccess, CallbackUrl, ConsumerKey, ConsumerSecret,SigningCertificate,
                            SigningCertificatePassword, DayWeekNumber, Hour, EmailsAlertTo, EmailSubjectError) {

        var VData = {
            SubGroups: SubGroups,
            EasyApiUser: EasyApiUser,
            EasyApiPassword: EasyApiPassword,
            ApiAddress: ApiAccess,
            CallbackUrl: CallbackUrl,
            ConsumerKey: ConsumerKey,
            ConsumerSecret: ConsumerSecret,
            SigningCertificate: SigningCertificate,
            SigningCertificatePassword: SigningCertificatePassword,
            DayWeekNumber: DayWeekNumber,
            Hour: Hour,
            EmailsAlertTo: EmailsAlertTo,
            EmailSubjectError: EmailSubjectError
        };
        return axios.post(BaseUrl+ 'SaveXeroSetting?CompanyCode='+CompanyCode+'&email='+email, VData);
    }

    static SaveExportToFTPSetting(CompanyCode,email, UserName, Pass, FtpServer, FtpPort, FtpUserName, FtpPassword, FtpPath, ExportSettingField) {

        var VData = {
            EasyApiUser: UserName,
            EasyApiPassword: Pass,
            FtpServer: FtpServer,
            FtpPort: FtpPort,
            FtpUsername: FtpUserName,
            FtpPassword: FtpPassword,
            FtpPath: FtpPath,
            ExportSettingField: ExportSettingField
        };
        return axios.post(BaseUrl+ 'SaveExportToFTP?CompanyCode='+CompanyCode+'&email='+email, VData);
    }

    static SaveDisconnectedDevices(CompanyCode, email, UserName, Pass, MinHoursDisconnected, EmailsTo, EmailFrom,EmailPhone, SerialDevices) {

        var VData = {
            EasyApiUser: UserName,
            EasyApiPassword: Pass,
            MinHoursDisconnected: MinHoursDisconnected,
            EmailsTo: EmailsTo,
            EmailFrom: EmailFrom,
            EmailPhone: EmailPhone,
            SerialDevices: SerialDevices
        };
        return axios.post(BaseUrl+ 'SaveDisconnectedDevices?CompanyCode='+CompanyCode+'&email='+email, VData);
    }

    static SaveAPISetting(CompanyCode, email, apiname) {

        return axios.post(BaseUrl+ 'SaveAPISetting?CompanyCode='+CompanyCode+'&apiname='+apiname+'&email='+email);
    }

    
    static DeleteAPISetting(CompanyCode, apiname, email) {

        return axios.delete(BaseUrl+ 'SaveAPISetting?CompanyCode='+CompanyCode+'&apiname='+apiname+'&email='+email);
    }

    static getAllDevices(CompanyCode, email) {

        return axios.get(BaseUrl+ 'AllDevice?CompanyCode='+CompanyCode+'&email='+email);
    }
}


// WEBPACK FOOTER //
// ./src/Services/APIService/apiService.js